import Icon from '../Icon';
import React, { PropsWithRef, useState, ReactNode, useEffect } from 'react';
import './Accordion.scss';

export type AccordionItem = {
	title: ReactNode;
	content: ReactNode;
	titleBorder?: boolean;
};

export type AccordionProps = {
	elements: AccordionItem[];
	defaultSelected?: number[];
};
export default function Accordion({
	elements = [],
	defaultSelected = [],
}: PropsWithRef<AccordionProps>) {
	const [selected, setSelected] = useState(defaultSelected);
	useEffect(() => {
		const set = new Set([...selected, ...defaultSelected]);
		if (set.size !== selected.length) {
			setSelected(Array.from(set));
		}
	}, [selected, defaultSelected]);

	const toggle = (i: number) => {
		const set = new Set([...selected]);

		if (set.has(i)) {
			set.delete(i);
			if (defaultSelected.includes(i)) {
				defaultSelected.splice(defaultSelected.indexOf(i), 1);
			}
		} else {
			set.add(i);
		}

		setSelected(Array.from(set));
	};
	return (
		<div className="ReactAccordion">
			{elements.map(({ title, content, titleBorder = true }, i) => (
				<div key={i} className="ReactAccordion-itemContainer">
					<div
						className={`ReactAccordion-title ty-c2 ${!titleBorder ? 'no-border' : ''}`}
						onClick={() => toggle(i)}
					>
						<h2> {title}</h2>
						<span className="ReactAccordion-plusSign">
							{selected.includes(i) ? (
								<Icon icon="less_sign"></Icon>
							) : (
								<Icon icon="plus_sign"></Icon>
							)}
						</span>
					</div>
					<div
						className={
							selected.includes(i)
								? 'ReactAccordion-content ReactAccordion-show ty-c3'
								: 'ReactAccordion-content ty-c3'
						}
					>
						{content}
					</div>
				</div>
			))}
		</div>
	);
}
